import Team from "../models/Team";
import Service from "../models/Service";
import ProjectPosition from "../models/ProjectPosition";
import {searchForTeams} from "./ClientRequests";


const teamMatches = ({queryKey, signal}) => {
    // const params = queryKey[1] || {};  // queryKey[0] is the original query key

    return searchForTeams({queryKey, signal});
}

const fetchTeamCandidateScope = async ({queryKey, signal}) => {
    const candidateId = queryKey[1];  // queryKey[0] is the original query key

    if (!candidateId) {
        throw new Error("Something went wront")
    }
    return Team.fetchTeamCandidateScope(candidateId, {signal})
}

const fetchAllServices = async ({ queryKey, signal }) => {
    let allServices = await Service.searchForTalent('', signal);
    if (!allServices) {
        throw new Error("Something went wrong")
    }

    return TB.orderBy([...allServices], 'category.display_index', 'desc');
}
const fetchTemplatesFromTags = ({queryKey, signal}) => {
    const tags = queryKey[1];
    return ProjectPosition.searchTemplates(tags, {signal})
}
const searchProjectTemplateTags = async ({queryKey, signal}) => {
    if (!queryKey[1]?.length) return [];
    const request = TB.request(
        TB.api_endpoint(`/api/project-templates/keywords/search?search=${queryKey[1]}`)
    )

    let response = await request.get({signal});

    return TB.get(response, 'success.data.tags', [])
}

const fetchProjectTemplate = ({queryKey, signal}) => {
    const templateId = queryKey[1];

    return Service.fetchTemplate(templateId, {signal})
}


const fetchServicesByCategory = ({ queryKey, signal }) => {
    const params = queryKey[1] || {};
    return Service.searchForClient(params, { signal });
}

export {
    teamMatches,
    fetchTeamCandidateScope,
    fetchAllServices,
    fetchTemplatesFromTags,
    searchProjectTemplateTags,
    fetchProjectTemplate,
    fetchServicesByCategory,
}